var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 377,
    viewBox: "0 0 412 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9771 75.5092C118.78 -0.503601 233.472 -13.1644 284.611 11.2611C305.976 21.4718 324.052 33.9705 339.154 47.7087C341.289 49.6441 343.367 51.608 345.379 53.5911C351.862 59.9787 357.735 66.576 363.045 73.2974C369.852 81.9064 375.725 90.7156 380.721 99.5153C388.767 113.663 394.564 127.773 398.387 140.959C401.409 151.369 403.201 161.208 403.897 170.046C405.356 188.551 404.088 207.19 401.6 225.58C401.371 227.335 401.123 229.089 400.856 230.843C400.789 231.329 400.723 231.815 400.646 232.302C397.91 250.578 394.039 269.016 385.402 284.957C375.982 302.337 343.043 350.702 307.339 351.97C288.815 352.627 272.455 340.5 255.666 331.939C228.953 318.325 198.759 315.655 169.3 314.864C139.84 314.073 110.019 314.921 81.3125 307.618C52.6063 300.325 24.4531 283.536 9.78062 255.612C4.79446 246.135 1.00955 232.483 1.00001 221.557C0.990479 189.323 6.26266 161.132 15.4532 136.64C18.4468 128.641 21.8599 121.043 25.6448 113.825C31.47 102.7 38.1817 92.4889 45.5895 83.1553L51.9771 75.5092Z",
    fill: "#DFFF02"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9771 75.5092C118.78 -0.503601 233.472 -13.1644 284.611 11.2611C305.976 21.4718 324.052 33.9705 339.154 47.7087C341.289 49.6441 343.367 51.608 345.379 53.5911C351.862 59.9787 357.735 66.576 363.045 73.2974C369.852 81.9064 375.725 90.7156 380.721 99.5153C388.767 113.663 394.564 127.773 398.387 140.959C401.409 151.369 403.201 161.208 403.897 170.046C405.356 188.551 404.088 207.19 401.6 225.58C401.371 227.335 401.123 229.089 400.856 230.843C400.789 231.329 400.723 231.815 400.646 232.302C397.91 250.578 394.039 269.016 385.402 284.957C375.982 302.337 343.043 350.702 307.339 351.97C288.815 352.627 272.455 340.5 255.666 331.939C228.953 318.325 198.759 315.655 169.3 314.864C139.84 314.073 110.019 314.921 81.3125 307.618C52.6063 300.325 24.4531 283.536 9.78062 255.612C4.79446 246.135 1.00955 232.483 1.00001 221.557C0.990479 189.323 6.26266 161.132 15.4532 136.64C18.4468 128.641 21.8599 121.043 25.6448 113.825C31.47 102.7 38.1817 92.4889 45.5895 83.1553L51.9771 75.5092Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 350.844H411",
    stroke: "#727272",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M316.529 212.537C316.519 212.547 316.519 212.556 316.529 212.566C316.538 212.604 316.548 212.632 316.558 212.671C316.596 212.842 316.624 213.023 316.672 213.214C316.996 214.749 317.368 216.865 317.635 219.535C317.816 221.356 317.959 223.434 317.997 225.751C318.083 230.222 317.835 235.58 316.901 241.71C316.691 243.112 316.443 244.552 316.148 246.039C315.68 248.46 315.099 250.996 314.403 253.618C314.079 254.838 313.726 256.087 313.345 257.346C313.192 257.861 313.04 258.366 312.897 258.881C312.725 259.501 312.553 260.13 312.382 260.749C312.382 260.759 312.372 260.768 312.372 260.778C311.266 265.001 310.408 269.33 309.75 273.63C308.94 279.016 308.435 284.365 308.158 289.427C307.786 296.167 307.806 302.402 307.968 307.56C307.968 307.646 307.968 307.722 307.977 307.808C308.149 313.033 308.473 317.113 308.692 319.449C308.816 320.803 308.902 321.575 308.911 321.632",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M316.557 212.67C316.547 212.651 316.547 212.651 316.538 212.651C316.528 212.632 316.528 212.632 316.519 212.632C315.832 212.031 315.079 211.507 314.288 211.078C313.411 210.62 312.477 210.258 311.514 210.029",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M316.557 212.67C316.547 212.651 316.547 212.651 316.538 212.651C316.528 212.632 316.528 212.632 316.519 212.632C315.832 212.031 315.079 211.507 314.288 211.078C313.411 210.62 312.477 210.258 311.514 210.029",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M317.625 219.534L320.161 217.236",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M314.394 253.637C314.261 252.96 314.07 252.302 313.794 251.673C313.422 250.748 312.907 249.88 312.278 249.108C311.811 248.527 311.277 248.002 310.686 247.535",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M312.363 260.788C313.059 259.014 314.547 257.546 316.329 256.869",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M307.959 296.252C308.807 295.232 309.446 291.333 309.799 289.235C309.885 288.73 309.952 288.311 310.009 287.996",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M307.959 296.252C308.807 295.232 309.446 291.333 309.799 289.235C309.885 288.73 309.952 288.311 310.009 287.996",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M301.428 303.289C301.714 303.27 302 303.279 302.286 303.317C304.755 303.546 307.072 305.243 307.977 307.56",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M301.428 303.289C301.714 303.27 302 303.279 302.286 303.317C304.755 303.546 307.072 305.243 307.977 307.56",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M316.138 246.087C316.138 246.087 316.586 230.614 308.092 225.008",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M316.901 279.294C318.017 282.897 310.237 289.771 310.237 289.771C310.237 289.771 299.941 288.484 298.825 284.88C297.71 281.277 300.322 275.366 305.308 273.831C310.304 272.277 315.786 275.69 316.901 279.294Z",
    fill: "#DFFF02"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M325.53 235.503C324.548 239.336 317.178 242.053 317.178 242.053C317.178 242.053 312.049 236.113 313.031 232.281C314.013 228.448 318.084 224.225 321.535 225.111C324.996 226.008 326.521 231.671 325.53 235.503Z",
    fill: "#DFFF02"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M295.984 292.774C300.608 294.576 303.439 302.756 303.439 302.756C303.439 302.756 295.822 306.865 291.198 305.063C286.574 303.261 281.683 298.189 282.999 294.795C284.324 291.401 291.36 290.972 295.984 292.774Z",
    fill: "#DFFF02"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M306.117 247.773C307.099 248.498 308.1 249.242 309.273 249.556C310.446 249.871 311.847 249.68 312.638 248.765C313.63 247.63 313.363 245.857 312.743 244.484C311.504 241.758 306.956 237.143 303.448 238.468C298.404 240.385 303.867 246.105 306.117 247.773Z",
    fill: "#DFFF02"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M316.462 254.715C315.794 255.535 315.098 256.574 315.461 257.566C315.785 258.443 316.862 258.853 317.787 258.71C318.712 258.567 319.522 258.023 320.285 257.49C322.068 256.25 325.729 253.657 323.393 251.226C320.962 248.69 317.854 252.98 316.462 254.715Z",
    fill: "#DFFF02"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M301.542 220.126C300.78 220.212 300.007 220.717 299.874 221.48C299.721 222.367 300.455 223.139 301.17 223.682C302.944 225.046 308.264 228.735 309.455 225.179C310.571 221.823 303.888 219.869 301.542 220.126Z",
    fill: "#DFFF02"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M311.353 208.438C310.256 208.542 309.16 208.142 308.054 208.209C306.958 208.275 305.728 209.162 305.976 210.239C306.204 211.231 307.434 211.565 308.454 211.631C310.19 211.736 311.944 211.622 313.65 211.269C314.051 211.193 314.48 211.069 314.699 210.735C315.147 210.077 314.432 209.2 313.679 208.971C312.926 208.743 312.068 208.819 311.381 208.428L311.353 208.438Z",
    fill: "#DFFF02"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M322.087 215.997C323.193 216.026 324.261 215.559 325.357 215.559C326.463 215.559 327.74 216.359 327.569 217.446C327.407 218.457 326.196 218.867 325.185 219C323.46 219.22 321.705 219.22 319.98 218.981C319.579 218.924 319.141 218.838 318.893 218.524C318.407 217.894 319.055 216.979 319.799 216.693C320.542 216.407 321.4 216.436 322.058 215.997H322.087Z",
    fill: "#DFFF02"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M321.001 297.244C321.277 297.016 321.582 296.777 321.935 296.777C322.412 296.777 322.784 297.225 322.869 297.693C322.955 298.16 322.831 298.636 322.688 299.085C321.945 301.582 313.545 319.697 311.619 316.446C310.475 314.52 313.288 308.151 314.108 306.349C315.719 302.869 318.064 299.723 321.001 297.244Z",
    fill: "#DFFF02"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M316.91 213.73C316.91 213.73 316.404 209.335 317.463 208.982",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M315.977 209.125C316.644 207.628 317.359 206.065 318.684 205.102C320.009 204.139 322.126 204.062 323.089 205.388C324.166 206.865 323.089 209.115 321.439 209.907C319.79 210.698 317.855 210.46 316.043 210.202C316.024 209.935 316.015 209.668 315.996 209.392L315.977 209.125Z",
    fill: "#DFFF02"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M320.495 350.625C311.571 352.15 302.266 352.15 293.343 350.625L282.779 319.459H331.058L320.495 350.625Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M136.246 125.455C136.236 125.465 136.236 125.474 136.246 125.484C136.255 125.522 136.265 125.55 136.274 125.589C136.312 125.76 136.341 125.941 136.389 126.132C136.713 127.667 137.085 129.783 137.352 132.453C137.533 134.274 137.676 136.352 137.714 138.669C137.8 143.14 137.552 148.498 136.618 154.628C136.408 156.03 136.16 157.47 135.864 158.957C135.397 161.378 134.816 163.914 134.12 166.536C133.796 167.756 133.443 168.996 133.061 170.264C132.909 170.779 132.756 171.284 132.613 171.799C132.442 172.418 132.27 173.048 132.099 173.667C132.099 173.677 132.089 173.686 132.089 173.696C130.983 177.919 130.125 182.248 129.467 186.548C128.657 191.934 128.152 197.283 127.875 202.345C127.503 209.085 127.522 215.32 127.684 220.478C127.684 220.564 127.684 220.64 127.694 220.726C127.866 225.951 128.19 230.031 128.409 232.367C128.533 233.721 128.619 234.493 128.628 234.55",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M136.264 125.588C136.255 125.569 136.255 125.569 136.245 125.569C136.235 125.55 136.235 125.55 136.226 125.55C135.54 124.949 134.786 124.425 133.995 123.996C133.118 123.538 132.184 123.176 131.221 122.947",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M136.264 125.588C136.255 125.569 136.255 125.569 136.245 125.569C136.235 125.55 136.235 125.55 136.226 125.55C135.54 124.949 134.786 124.425 133.995 123.996C133.118 123.538 132.184 123.176 131.221 122.947",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M137.342 132.452L139.878 130.154",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M134.101 166.555C133.968 165.878 133.777 165.22 133.501 164.591C133.129 163.666 132.614 162.798 131.985 162.026C131.518 161.445 130.984 160.92 130.393 160.453",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M132.08 173.705C132.776 171.932 134.263 170.464 136.046 169.787",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M127.666 209.17C128.515 208.15 129.153 204.251 129.506 202.153C129.592 201.648 129.659 201.229 129.716 200.914",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M127.666 209.17C128.515 208.15 129.153 204.251 129.506 202.153C129.592 201.648 129.659 201.229 129.716 200.914",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M121.135 216.207C121.421 216.188 121.707 216.197 121.993 216.235C124.462 216.464 126.779 218.161 127.684 220.478",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M121.135 216.207C121.421 216.188 121.707 216.197 121.993 216.235C124.462 216.464 126.779 218.161 127.684 220.478",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M135.845 159.005C135.845 159.005 136.293 143.532 127.799 137.926",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M136.618 192.212C137.734 195.815 129.954 202.689 129.954 202.689C129.954 202.689 119.658 201.402 118.542 197.798C117.427 194.195 120.039 188.284 125.025 186.749C130.021 185.195 135.503 188.608 136.618 192.212Z",
    fill: "#DFFF02"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M145.245 148.421C144.263 152.254 136.893 154.971 136.893 154.971C136.893 154.971 131.764 149.031 132.746 145.199C133.728 141.366 137.799 137.143 141.25 138.029C144.701 138.926 146.227 144.589 145.245 148.421Z",
    fill: "#DFFF02"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M115.691 205.692C120.315 207.494 123.146 215.674 123.146 215.674C123.146 215.674 115.529 219.783 110.905 217.981C106.281 216.179 101.39 211.107 102.706 207.713C104.031 204.319 111.067 203.89 115.691 205.692Z",
    fill: "#DFFF02"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M125.834 160.691C126.816 161.416 127.817 162.16 128.99 162.474C130.162 162.789 131.564 162.598 132.355 161.683C133.347 160.548 133.08 158.775 132.46 157.402C131.221 154.676 126.673 150.061 123.164 151.386C118.121 153.303 123.574 159.023 125.834 160.691Z",
    fill: "#DFFF02"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M136.169 167.633C135.501 168.453 134.805 169.492 135.168 170.484C135.492 171.361 136.569 171.771 137.494 171.628C138.419 171.485 139.229 170.941 139.992 170.408C141.775 169.168 145.436 166.575 143.1 164.144C140.678 161.608 137.57 165.898 136.169 167.633Z",
    fill: "#DFFF02"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M121.249 133.044C120.487 133.13 119.714 133.635 119.581 134.398C119.428 135.285 120.162 136.057 120.877 136.6C122.651 137.964 127.971 141.653 129.162 138.097C130.278 134.741 123.604 132.787 121.249 133.044Z",
    fill: "#DFFF02"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M131.06 121.356C129.963 121.46 128.867 121.06 127.761 121.127C126.665 121.193 125.435 122.08 125.683 123.157C125.911 124.149 127.141 124.483 128.161 124.549C129.897 124.654 131.651 124.54 133.357 124.187C133.758 124.111 134.187 123.987 134.406 123.653C134.854 122.995 134.139 122.118 133.386 121.889C132.633 121.661 131.775 121.737 131.088 121.346L131.06 121.356Z",
    fill: "#DFFF02"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M141.794 128.915C142.9 128.944 143.968 128.477 145.064 128.477C146.17 128.477 147.447 129.277 147.276 130.364C147.114 131.375 145.903 131.785 144.892 131.918C143.167 132.138 141.413 132.138 139.687 131.899C139.286 131.842 138.848 131.756 138.6 131.442C138.114 130.812 138.762 129.897 139.506 129.611C140.249 129.325 141.107 129.354 141.765 128.915H141.794Z",
    fill: "#DFFF02"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M140.708 210.162C140.984 209.934 141.289 209.695 141.642 209.695C142.119 209.695 142.491 210.143 142.576 210.611C142.662 211.078 142.538 211.554 142.395 212.002C141.652 214.5 133.252 232.615 131.327 229.363C130.182 227.438 132.995 221.069 133.815 219.267C135.426 215.787 137.771 212.641 140.708 210.162Z",
    fill: "#DFFF02"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M136.617 126.648C136.617 126.648 136.111 122.253 137.17 121.9",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M135.693 122.043C136.361 120.546 137.076 118.982 138.401 118.02C139.726 117.057 141.843 116.98 142.806 118.306C143.883 119.783 142.806 122.033 141.156 122.825C139.507 123.616 137.572 123.378 135.76 123.12C135.741 122.853 135.731 122.586 135.712 122.31L135.693 122.043Z",
    fill: "#DFFF02"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4531 230.84V136.637",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M309.57 230.84H297.93",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M400.855 230.84H377.145",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M296.861 87.7298H338.877V47.707",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9766 75.5078H96.6137V108.066H145.541",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6445 185.764V113.822",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5898 82.5996V138.982",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5234 82.5996V132.442",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M85.459 82.5996V169.786",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M180.959 70.2348V12.9082H262.12V70.2348",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M186.908 41.3849V19.7051H201.914",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M205.213 41.3849V19.7051H220.219",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M223.518 41.3849V19.7051H238.524",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M241.822 41.3849V19.7051H256.828",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M186.908 70.2347V48.5645H201.914",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M205.213 70.2347V48.5645H220.219",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M223.518 70.2347V48.5645H238.524",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M241.822 70.2347V48.5645H256.828",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M345.379 52.6641V124.501",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M374.848 225.578H377.145",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M363.045 73.2949V153.722",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M380.721 205.043V225.579H394.821",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M380.721 99.5137V154.133",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M398.387 140.957V225.579H401.6",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M183.095 232.568H1V350.844H183.095V232.568Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1 232.568L92.0476 291.706L183.095 232.568H1Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6761 273.926L1 350.844",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M119.914 273.926L183.59 350.844",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M283.038 75.3945H161.854C155.085 75.3945 149.594 80.9813 149.594 87.8838V337.345C149.594 344.237 155.085 349.834 161.854 349.834H283.038C289.807 349.834 295.308 344.237 295.308 337.345V87.8838C295.318 80.9813 289.807 75.3945 283.038 75.3945ZM287.643 329.632C287.643 336.2 282.723 341.511 276.66 341.511H168.251C162.169 341.511 157.259 336.2 157.259 329.632V97.3413C157.259 83.9654 162.178 83.3171 168.251 83.3171H189.969C191.228 83.3171 192.267 84.7472 192.267 86.53V87.2927C192.267 91.4589 194.546 91.4685 197.339 91.4685H247.563C250.385 91.4685 252.654 91.4494 252.654 87.2927V86.53C252.654 84.7567 253.674 83.3171 254.951 83.3171H276.66C282.723 83.3171 287.643 85.0904 287.643 97.3413V329.632Z",
    fill: "#4A4A4A"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M287.653 97.3406V329.641C287.653 336.209 282.734 341.52 276.671 341.52H168.262C162.179 341.52 157.27 336.209 157.27 329.641V97.3406C157.27 83.9647 162.189 83.3164 168.262 83.3164H189.98C191.238 83.3164 192.278 84.7465 192.278 86.5293V87.292C192.278 91.4583 194.556 91.4678 197.35 91.4678H247.573C250.395 91.4678 252.664 91.4488 252.664 87.292V86.5293C252.664 84.7561 253.685 83.3164 254.962 83.3164H276.671C282.734 83.3069 287.653 85.0897 287.653 97.3406Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M287.653 97.3406V118.42H157.26V97.3406C157.26 83.9647 162.179 83.3164 168.252 83.3164H189.97C191.229 83.3164 192.268 84.7465 192.268 86.5293V87.292C192.268 91.4583 194.546 91.4678 197.34 91.4678H247.564C250.386 91.4678 252.655 91.4488 252.655 87.292V86.5293C252.655 84.7561 253.675 83.3164 254.952 83.3164H276.661C282.734 83.3069 287.653 85.0897 287.653 97.3406Z",
    fill: "#DFFF02"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M229.306 86.0622H215.606C215.139 86.0622 214.758 85.6809 214.758 85.2137C214.758 84.7466 215.139 84.3652 215.606 84.3652H229.306C229.774 84.3652 230.155 84.7466 230.155 85.2137C230.145 85.6809 229.774 86.0622 229.306 86.0622Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M186.224 88.3218C186.157 88.3886 186.081 88.4648 186.014 88.5316C185.976 88.5697 185.938 88.6078 185.899 88.6555C185.337 88.1121 184.66 87.8165 183.878 87.8165C183.097 87.8165 182.42 88.1026 181.857 88.6555C181.819 88.6174 181.781 88.5792 181.743 88.5411C181.676 88.4744 181.609 88.3981 181.533 88.3314C181.533 88.3314 181.533 88.3314 181.523 88.3314C181.523 88.3314 181.523 88.3314 181.523 88.3218C181.533 88.3218 181.533 88.3123 181.543 88.3123C181.628 88.236 181.714 88.1502 181.809 88.0739C182 87.9214 182.2 87.7879 182.42 87.6831C182.677 87.5591 182.954 87.4638 183.23 87.4066C183.363 87.378 183.497 87.3685 183.64 87.3494C183.688 87.3399 183.983 87.3398 183.993 87.3398C184.088 87.3494 184.174 87.3494 184.269 87.3589C184.527 87.3875 184.774 87.4447 185.013 87.5401C185.184 87.6068 185.356 87.6831 185.518 87.7784C185.69 87.8737 185.852 87.9881 186.004 88.1121C186.071 88.1788 186.147 88.2456 186.224 88.3218Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M182.515 89.314C182.401 89.1996 182.296 89.0948 182.182 88.9804C182.563 88.6085 183.002 88.3702 183.535 88.3035C184.317 88.1986 184.994 88.4369 185.566 88.9804C185.452 89.0948 185.347 89.1996 185.232 89.314C184.861 88.9518 184.403 88.7515 183.879 88.7515C183.345 88.7515 182.887 88.9422 182.515 89.314Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M184.899 89.6366C184.794 89.7414 184.68 89.8559 184.565 89.9703C184.375 89.7891 184.146 89.6842 183.869 89.6842C183.603 89.6842 183.364 89.7891 183.174 89.9703C183.059 89.8559 182.954 89.751 182.84 89.6366C183.374 89.0931 184.318 89.0455 184.899 89.6366Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M184.163 90.2662C184.163 90.4283 184.03 90.5618 183.868 90.5618C183.706 90.5618 183.572 90.4283 183.572 90.2662C183.572 90.1042 183.706 89.9707 183.868 89.9707C184.03 89.9707 184.163 90.1042 184.163 90.2662Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M165.754 88.9613C165.754 88.4846 166.145 88.0938 166.621 88.0938C167.098 88.0938 167.489 88.4846 167.489 88.9613C167.489 89.438 167.098 89.8289 166.621 89.8289C166.145 89.8194 165.754 89.438 165.754 88.9613Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M168.48 88.9613C168.48 88.4846 168.871 88.0938 169.348 88.0938C169.825 88.0938 170.216 88.4846 170.216 88.9613C170.216 89.438 169.825 89.8289 169.348 89.8289C168.871 89.8194 168.48 89.438 168.48 88.9613Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M171.197 88.9613C171.197 88.4846 171.588 88.0938 172.065 88.0938C172.542 88.0938 172.932 88.4846 172.932 88.9613C172.932 89.438 172.542 89.8289 172.065 89.8289C171.588 89.8194 171.197 89.438 171.197 88.9613Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M173.924 88.9613C173.924 88.4846 174.315 88.0938 174.791 88.0938C175.268 88.0938 175.659 88.4846 175.659 88.9613C175.659 89.438 175.268 89.8289 174.791 89.8289C174.315 89.8194 173.924 89.438 173.924 88.9613Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M176.641 88.9613C176.641 88.4846 177.032 88.0938 177.508 88.0938C177.985 88.0938 178.376 88.4846 178.376 88.9613C178.376 89.438 177.985 89.8289 177.508 89.8289C177.032 89.8194 176.641 89.438 176.641 88.9613Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M277.862 90.8387H270.826V87.5781H277.862V90.8387ZM271.188 90.4859H277.509V87.9404H271.188V90.4859Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 88.1406H271.418V90.2953H275.956V88.1406Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M278.5 88.3418H277.871V90.0865H278.5V88.3418Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M169.615 110.354L165.754 106.74L169.615 103.137L170.206 103.766L167.031 106.74L170.206 109.715L169.615 110.354Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M271.446 106.14C271.608 106.236 271.694 106.407 271.684 106.588C271.684 106.636 271.684 106.684 271.684 106.741C271.684 106.789 271.684 106.846 271.684 106.894C271.694 107.075 271.608 107.246 271.446 107.342L270.902 107.656L271.922 109.42L272.466 109.105C272.628 109.01 272.819 109.02 272.971 109.124C273.057 109.182 273.143 109.229 273.238 109.277C273.4 109.363 273.505 109.525 273.505 109.706V110.326H275.545V109.706C275.545 109.525 275.65 109.363 275.812 109.277C275.898 109.229 275.993 109.182 276.079 109.124C276.232 109.02 276.432 109.02 276.584 109.105L277.128 109.42L278.148 107.656L277.605 107.342C277.443 107.246 277.357 107.075 277.366 106.894C277.366 106.846 277.366 106.798 277.366 106.741C277.366 106.693 277.366 106.636 277.366 106.588C277.357 106.407 277.443 106.226 277.605 106.14L278.148 105.826L277.128 104.062L276.584 104.377C276.422 104.472 276.232 104.462 276.079 104.358C275.993 104.3 275.908 104.253 275.812 104.205C275.65 104.119 275.545 103.957 275.545 103.776V103.156H273.505V103.776C273.505 103.957 273.4 104.119 273.238 104.205C273.143 104.253 273.057 104.3 272.971 104.358C272.819 104.462 272.618 104.462 272.466 104.377L271.922 104.062L270.902 105.826L271.446 106.14ZM274.525 105.073C275.45 105.073 276.194 105.826 276.194 106.741C276.194 107.666 275.44 108.409 274.525 108.409C273.6 108.409 272.857 107.666 272.857 106.741C272.857 105.816 273.6 105.073 274.525 105.073Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M211.24 104.568C211.24 104.33 211.421 104.148 211.66 104.148C211.889 104.148 212.089 104.33 212.089 104.568V109.077C212.089 109.316 211.889 109.497 211.66 109.497C211.421 109.497 211.24 109.316 211.24 109.077V104.568Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M214.358 109.077C214.358 109.306 214.167 109.497 213.948 109.497C213.709 109.497 213.528 109.306 213.528 109.077V104.635C213.528 104.635 213.528 104.635 213.528 104.625C213.519 104.492 213.585 104.358 213.7 104.272C213.891 104.139 214.148 104.177 214.281 104.368L216.751 107.781V104.635C216.751 104.415 216.932 104.225 217.161 104.225C217.389 104.225 217.58 104.415 217.58 104.635V109.077C217.58 109.306 217.389 109.497 217.161 109.497C217.037 109.497 216.922 109.44 216.846 109.344C216.827 109.325 216.817 109.316 216.808 109.297L214.358 105.903V109.077Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M219.41 109.077V104.568C219.41 104.33 219.601 104.148 219.83 104.148C219.839 104.148 219.839 104.148 219.849 104.148C219.849 104.148 219.849 104.148 219.858 104.148H220.916C221.717 104.148 222.366 104.797 222.366 105.598C222.366 105.922 222.261 106.227 222.08 106.465C222.537 106.751 222.852 107.266 222.852 107.848C222.852 108.753 222.118 109.487 221.212 109.487H219.858C219.849 109.487 219.849 109.478 219.849 109.478C219.83 109.478 219.83 109.487 219.83 109.487C219.601 109.497 219.41 109.306 219.41 109.077ZM220.259 106.217H220.916C221.25 106.217 221.517 105.931 221.517 105.598C221.517 105.264 221.25 104.997 220.916 104.997H220.259V106.217ZM220.259 108.648H221.212C221.651 108.639 222.003 108.296 222.003 107.857C222.003 107.419 221.651 107.075 221.212 107.066H220.259V108.648Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M228.181 104.806C228.657 105.312 228.953 105.988 228.953 106.742C228.953 107.495 228.657 108.181 228.181 108.677C227.733 109.173 227.056 109.497 226.35 109.497C225.616 109.497 224.939 109.173 224.482 108.677C224.005 108.181 223.729 107.495 223.729 106.742C223.729 105.988 224.015 105.312 224.482 104.806C224.949 104.301 225.616 103.986 226.35 103.986C227.056 103.986 227.723 104.301 228.181 104.806ZM228.076 106.742C228.076 106.217 227.866 105.741 227.552 105.407C227.227 105.064 226.798 104.863 226.341 104.863C225.855 104.863 225.426 105.064 225.101 105.407C224.777 105.741 224.577 106.227 224.577 106.742C224.577 107.266 224.777 107.743 225.101 108.076C225.426 108.42 225.855 108.629 226.341 108.629C226.798 108.629 227.227 108.42 227.552 108.076C227.876 107.743 228.076 107.266 228.076 106.742Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M233.911 104.873L232.462 106.846L233.911 108.829C234.044 109.01 234.006 109.277 233.816 109.411C233.739 109.468 233.654 109.496 233.568 109.496C233.434 109.496 233.31 109.43 233.225 109.325L231.938 107.561L230.65 109.325C230.565 109.43 230.441 109.496 230.317 109.496C230.221 109.496 230.145 109.468 230.069 109.411C229.878 109.277 229.84 109.01 229.974 108.829L231.423 106.846L229.974 104.873C229.84 104.682 229.878 104.424 230.069 104.291C230.25 104.148 230.517 104.186 230.65 104.386L231.938 106.141L233.225 104.386C233.368 104.186 233.625 104.148 233.816 104.291C234.006 104.415 234.035 104.682 233.911 104.873Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M250.033 131.014H170.111V136.019H250.033V131.014Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M250.081 136.077H170.055V130.967H250.081V136.077Z",
    fill: "#EDEDED"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M250.081 130.967H244.971V136.077H250.081V130.967Z",
    fill: "#DFFF02"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M249.118 134.922L248.651 135.275L247.793 134.14L247.479 133.73C247.545 133.702 247.602 133.673 247.66 133.625C247.765 133.54 247.85 133.435 247.898 133.32L248.232 133.759L249.118 134.922Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M248.204 132.263C247.775 131.71 246.984 131.605 246.431 132.034C245.878 132.463 245.773 133.254 246.202 133.807C246.583 134.303 247.26 134.436 247.794 134.15C247.851 134.122 247.918 134.084 247.966 134.036C248.071 133.96 248.156 133.864 248.223 133.76C248.547 133.321 248.547 132.711 248.204 132.263ZM247.661 133.626C247.603 133.674 247.546 133.702 247.479 133.731C247.174 133.855 246.812 133.769 246.602 133.493C246.345 133.159 246.412 132.692 246.745 132.434C247.079 132.177 247.546 132.244 247.804 132.577C247.975 132.797 248.004 133.083 247.899 133.331C247.851 133.435 247.775 133.54 247.661 133.626Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M171.417 132.006H171.15V135.047H171.417V132.006Z",
    fill: "#D9D9D9"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M281.704 128.459C281.408 128.641 281.084 128.784 280.722 128.869C279.797 129.098 278.872 128.917 278.129 128.459C277.394 128.011 276.832 127.277 276.613 126.372C276.165 124.541 277.28 122.701 279.11 122.262C280.931 121.814 282.781 122.939 283.22 124.76C283.582 126.229 282.924 127.706 281.704 128.459Z",
    fill: "#DFFF02"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M280.951 125.18C280.951 125.752 280.484 126.219 279.912 126.219C279.34 126.219 278.873 125.752 278.873 125.18C278.873 124.608 279.34 124.141 279.912 124.141C280.494 124.141 280.951 124.608 280.951 125.18Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M281.704 128.031V128.46C281.409 128.641 281.084 128.784 280.722 128.87C279.797 129.098 278.873 128.917 278.129 128.46V128.031C278.129 127.049 278.93 126.238 279.921 126.238C280.913 126.238 281.704 127.049 281.704 128.031Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M287.653 144.096H157.26V154.43H287.653V144.096Z",
    fill: "#EDEDED"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 147.709H165.354V150.817H168.462V147.709Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 150.817H178.549L179.807 149.263L178.549 147.709H181.647L182.915 149.263L181.647 150.817Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 147.709L174.173 148.739L175.307 148.901L174.487 149.692L174.678 150.817L173.667 150.293L172.657 150.817L172.857 149.692L172.037 148.901L173.162 148.739L173.667 147.709Z",
    fill: "#DFFF02"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 148.633H185.146V149.901H209.887V148.633Z",
    fill: "#4A4A4A"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 148.633H251.883V149.901H274.344V148.633Z",
    fill: "#4A4A4A"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 148.633H217.436V149.901H242.452V148.633Z",
    fill: "#212121"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 158.053H165.354V161.161H168.462V158.053Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 161.161H178.549L179.807 159.607L178.549 158.053H181.647L182.915 159.607L181.647 161.161Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 158.053L174.173 159.073L175.307 159.235L174.487 160.036L174.678 161.161L173.667 160.627L172.657 161.161L172.857 160.036L172.037 159.235L173.162 159.073L173.667 158.053Z",
    fill: "#DFFF02"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 158.969H185.146V160.227H209.887V158.969Z",
    fill: "#4A4A4A"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 158.969H251.883V160.227H274.344V158.969Z",
    fill: "#4A4A4A"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 158.969H217.436V160.227H242.452V158.969Z",
    fill: "#212121"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M287.653 164.775H157.26V175.11H287.653V164.775Z",
    fill: "#EDEDED"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 168.389H165.354V171.497H168.462V168.389Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 171.497H178.549L179.807 169.943L178.549 168.389H181.647L182.915 169.943L181.647 171.497Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 168.389L174.173 169.409L175.307 169.58L174.487 170.372L174.678 171.497L173.667 170.963L172.657 171.497L172.857 170.372L172.037 169.58L173.162 169.409L173.667 168.389Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 169.312H185.146V170.571H209.887V169.312Z",
    fill: "#D9D9D9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 169.312H251.883V170.571H274.344V169.312Z",
    fill: "#D9D9D9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 169.312H217.436V170.571H242.452V169.312Z",
    fill: "#D9D9D9"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 178.723H165.354V181.831H168.462V178.723Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 181.831H178.549L179.807 180.277L178.549 178.723H181.647L182.915 180.277L181.647 181.831Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 178.723L174.173 179.752L175.307 179.914L174.487 180.706L174.678 181.831L173.667 181.306L172.657 181.831L172.857 180.706L172.037 179.914L173.162 179.752L173.667 178.723Z",
    fill: "#DFFF02"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 179.646H185.146V180.905H209.887V179.646Z",
    fill: "#D9D9D9"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 179.646H251.883V180.905H274.344V179.646Z",
    fill: "#D9D9D9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 179.646H217.436V180.905H242.452V179.646Z",
    fill: "#D9D9D9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M287.653 185.453H157.26V195.788H287.653V185.453Z",
    fill: "#EDEDED"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 189.066H165.354V192.174H168.462V189.066Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 192.174H178.549L179.807 190.62L178.549 189.066H181.647L182.915 190.62L181.647 192.174Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 189.066L174.173 190.087L175.307 190.249L174.487 191.049L174.678 192.174L173.667 191.641L172.657 192.174L172.857 191.049L172.037 190.249L173.162 190.087L173.667 189.066Z",
    fill: "#DFFF02"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 189.982H185.146V191.241H209.887V189.982Z",
    fill: "#D9D9D9"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 189.982H251.883V191.241H274.344V189.982Z",
    fill: "#D9D9D9"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 189.982H217.436V191.241H242.452V189.982Z",
    fill: "#D9D9D9"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 199.4H165.354V202.508H168.462V199.4Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 202.508H178.549L179.807 200.954L178.549 199.4H181.647L182.915 200.954L181.647 202.508Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 199.4L174.173 200.421L175.307 200.592L174.487 201.383L174.678 202.508L173.667 201.975L172.657 202.508L172.857 201.383L172.037 200.592L173.162 200.421L173.667 199.4Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 200.324H185.146V201.583H209.887V200.324Z",
    fill: "#D9D9D9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 200.324H251.883V201.583H274.344V200.324Z",
    fill: "#D9D9D9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 200.324H217.436V201.583H242.452V200.324Z",
    fill: "#D9D9D9"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M287.653 206.123H157.26V216.458H287.653V206.123Z",
    fill: "#EDEDED"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 209.736H165.354V212.844H168.462V209.736Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 212.844H178.549L179.807 211.29L178.549 209.736H181.647L182.915 211.29L181.647 212.844Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 209.736L174.173 210.766L175.307 210.928L174.487 211.719L174.678 212.844L173.667 212.32L172.657 212.844L172.857 211.719L172.037 210.928L173.162 210.766L173.667 209.736Z",
    fill: "#DFFF02"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 210.66H185.146V211.928H209.887V210.66Z",
    fill: "#D9D9D9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 210.66H251.883V211.928H274.344V210.66Z",
    fill: "#D9D9D9"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 210.66H217.436V211.928H242.452V210.66Z",
    fill: "#D9D9D9"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 220.08H165.354V223.188H168.462V220.08Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 223.188H178.549L179.807 221.634L178.549 220.08H181.647L182.915 221.634L181.647 223.188Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 220.08L174.173 221.1L175.307 221.262L174.487 222.063L174.678 223.188L173.667 222.654L172.657 223.188L172.857 222.063L172.037 221.262L173.162 221.1L173.667 220.08Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 220.996H185.146V222.264H209.887V220.996Z",
    fill: "#D9D9D9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 220.996H251.883V222.264H274.344V220.996Z",
    fill: "#D9D9D9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 220.996H217.436V222.264H242.452V220.996Z",
    fill: "#D9D9D9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M287.653 226.801H157.26V237.135H287.653V226.801Z",
    fill: "#EDEDED"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 230.414H165.354V233.522H168.462V230.414Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 233.522H178.549L179.807 231.968L178.549 230.414H181.647L182.915 231.968L181.647 233.522Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 230.414L174.173 231.434L175.307 231.606L174.487 232.397L174.678 233.522L173.667 232.988L172.657 233.522L172.857 232.397L172.037 231.606L173.162 231.434L173.667 230.414Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 231.338H185.146V232.606H209.887V231.338Z",
    fill: "#D9D9D9"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 231.338H251.883V232.606H274.344V231.338Z",
    fill: "#D9D9D9"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 231.338H217.436V232.606H242.452V231.338Z",
    fill: "#D9D9D9"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 240.75H165.354V243.858H168.462V240.75Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 243.858H178.549L179.807 242.304L178.549 240.75H181.647L182.915 242.304L181.647 243.858Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 240.75L174.173 241.78L175.307 241.942L174.487 242.733L174.678 243.858L173.667 243.334L172.657 243.858L172.857 242.733L172.037 241.942L173.162 241.78L173.667 240.75Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 241.674H185.146V242.932H209.887V241.674Z",
    fill: "#D9D9D9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 241.674H251.883V242.932H274.344V241.674Z",
    fill: "#D9D9D9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 241.674H217.436V242.932H242.452V241.674Z",
    fill: "#D9D9D9"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M287.653 247.48H157.26V257.815H287.653V247.48Z",
    fill: "#EDEDED"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 251.094H165.354V254.202H168.462V251.094Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 254.202H178.549L179.807 252.648L178.549 251.094H181.647L182.915 252.648L181.647 254.202Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 251.094L174.173 252.114L175.307 252.276L174.487 253.077L174.678 254.202L173.667 253.668L172.657 254.202L172.857 253.077L172.037 252.276L173.162 252.114L173.667 251.094Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 252.01H185.146V253.268H209.887V252.01Z",
    fill: "#D9D9D9"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 252.01H251.883V253.268H274.344V252.01Z",
    fill: "#D9D9D9"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 252.01H217.436V253.268H242.452V252.01Z",
    fill: "#D9D9D9"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 261.428H165.354V264.536H168.462V261.428Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 264.536H178.549L179.807 262.982L178.549 261.428H181.647L182.915 262.982L181.647 264.536Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 261.428L174.173 262.448L175.307 262.619L174.487 263.411L174.678 264.536L173.667 264.002L172.657 264.536L172.857 263.411L172.037 262.619L173.162 262.448L173.667 261.428Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 262.352H185.146V263.61H209.887V262.352Z",
    fill: "#D9D9D9"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 262.352H251.883V263.61H274.344V262.352Z",
    fill: "#D9D9D9"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 262.352H217.436V263.61H242.452V262.352Z",
    fill: "#D9D9D9"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M287.653 268.148H157.26V278.483H287.653V268.148Z",
    fill: "#EDEDED"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 271.762H165.354V274.87H168.462V271.762Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 274.87H178.549L179.807 273.316L178.549 271.762H181.647L182.915 273.316L181.647 274.87Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 271.762L174.173 272.791L175.307 272.953L174.487 273.745L174.678 274.87L173.667 274.345L172.657 274.87L172.857 273.745L172.037 272.953L173.162 272.791L173.667 271.762Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 272.686H185.146V273.944H209.887V272.686Z",
    fill: "#D9D9D9"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 272.686H251.883V273.944H274.344V272.686Z",
    fill: "#D9D9D9"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 272.686H217.436V273.944H242.452V272.686Z",
    fill: "#D9D9D9"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 282.107H165.354V285.215H168.462V282.107Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 285.215H178.549L179.807 283.661L178.549 282.107H181.647L182.915 283.661L181.647 285.215Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 282.107L174.173 283.128L175.307 283.29L174.487 284.09L174.678 285.215L173.667 284.682L172.657 285.215L172.857 284.09L172.037 283.29L173.162 283.128L173.667 282.107Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 283.023H185.146V284.282H209.887V283.023Z",
    fill: "#D9D9D9"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 283.023H251.883V284.282H274.344V283.023Z",
    fill: "#D9D9D9"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 283.023H217.436V284.282H242.452V283.023Z",
    fill: "#D9D9D9"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M287.653 288.828H157.26V299.163H287.653V288.828Z",
    fill: "#EDEDED"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 292.441H165.354V295.549H168.462V292.441Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 295.549H178.549L179.807 293.995L178.549 292.441H181.647L182.915 293.995L181.647 295.549Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 292.441L174.173 293.462L175.307 293.633L174.487 294.424L174.678 295.549L173.667 295.016L172.657 295.549L172.857 294.424L172.037 293.633L173.162 293.462L173.667 292.441Z",
    fill: "#DFFF02"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 293.365H185.146V294.624H209.887V293.365Z",
    fill: "#D9D9D9"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 293.365H251.883V294.624H274.344V293.365Z",
    fill: "#D9D9D9"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 293.365H217.436V294.624H242.452V293.365Z",
    fill: "#D9D9D9"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 302.775H165.354V305.883H168.462V302.775Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 305.883H178.549L179.807 304.329L178.549 302.775H181.647L182.915 304.329L181.647 305.883Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 302.775L174.173 303.805L175.307 303.967L174.487 304.758L174.678 305.883L173.667 305.359L172.657 305.883L172.857 304.758L172.037 303.967L173.162 303.805L173.667 302.775Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 303.699H185.146V304.958H209.887V303.699Z",
    fill: "#D9D9D9"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 303.699H251.883V304.958H274.344V303.699Z",
    fill: "#D9D9D9"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 303.699H217.436V304.958H242.452V303.699Z",
    fill: "#D9D9D9"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M287.653 309.506H157.26V319.84H287.653V309.506Z",
    fill: "#EDEDED"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 313.119H165.354V316.227H168.462V313.119Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 316.227H178.549L179.807 314.673L178.549 313.119H181.647L182.915 314.673L181.647 316.227Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 313.119L174.173 314.139L175.307 314.301L174.487 315.102L174.678 316.227L173.667 315.693L172.657 316.227L172.857 315.102L172.037 314.301L173.162 314.139L173.667 313.119Z",
    fill: "#DFFF02"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 314.035H185.146V315.294H209.887V314.035Z",
    fill: "#D9D9D9"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 314.035H251.883V315.294H274.344V314.035Z",
    fill: "#D9D9D9"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 314.035H217.436V315.294H242.452V314.035Z",
    fill: "#D9D9D9"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 323.455H165.354V326.563H168.462V323.455Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 326.563H178.549L179.807 325.009L178.549 323.455H181.647L182.915 325.009L181.647 326.563Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 323.455L174.173 324.475L175.307 324.647L174.487 325.438L174.678 326.563L173.667 326.029L172.657 326.563L172.857 325.438L172.037 324.647L173.162 324.475L173.667 323.455Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 324.379H185.146V325.647H209.887V324.379Z",
    fill: "#D9D9D9"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 324.379H251.883V325.647H274.344V324.379Z",
    fill: "#D9D9D9"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 324.379H217.436V325.647H242.452V324.379Z",
    fill: "#D9D9D9"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M287.635 330.176C287.444 334.819 284.794 338.766 281.066 340.51H163.858C160.111 338.756 157.47 334.809 157.279 330.176H287.635Z",
    fill: "#EDEDED"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M168.462 333.789H165.354V336.897H168.462V333.789Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M181.647 336.897H178.549L179.807 335.343L178.549 333.789H181.647L182.915 335.343L181.647 336.897Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M173.667 333.789L174.173 334.819L175.307 334.981L174.487 335.772L174.678 336.897L173.667 336.373L172.657 336.897L172.857 335.772L172.037 334.981L173.162 334.819L173.667 333.789Z",
    fill: "#DFFF02"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M209.887 334.713H185.146V335.971H209.887V334.713Z",
    fill: "#D9D9D9"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M274.344 334.713H251.883V335.971H274.344V334.713Z",
    fill: "#D9D9D9"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M242.452 334.713H217.436V335.971H242.452V334.713Z",
    fill: "#D9D9D9"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M287.948 97.0261V329.326C287.948 335.895 283.029 341.205 276.965 341.205H168.547C162.465 341.205 157.555 335.895 157.555 329.326V97.0261C157.555 83.6503 162.474 83.002 168.547 83.002H190.265C191.524 83.002 192.563 84.432 192.563 86.2148V86.9776C192.563 91.1438 194.841 91.1533 197.635 91.1533H247.859C250.681 91.1533 252.95 91.1343 252.95 86.9776V86.2148C252.95 84.4416 253.97 83.002 255.247 83.002H276.956C283.029 83.002 287.948 84.7752 287.948 97.0261Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M293.63 87.7303C293.63 80.9804 288.158 75.5176 281.418 75.5176C281.418 75.5176 281.418 75.5176 281.408 75.5176H162.074C155.324 75.5176 149.852 80.9804 149.852 87.7303C149.852 87.7303 149.852 87.7303 149.852 87.7399V338.64C149.852 345.39 155.324 350.853 162.064 350.853C162.064 350.853 162.064 350.853 162.074 350.853H281.408C288.158 350.853 293.63 345.39 293.63 338.64C293.63 338.64 293.63 338.64 293.63 338.631V87.7303ZM289.502 329.106C289.436 333.988 285.422 337.897 280.541 337.83H162.932C158.051 337.887 154.046 333.988 153.98 329.106V90.3712C154.046 85.4899 158.051 81.5811 162.932 81.6478H205.224C207.731 81.6478 210.029 83.0207 211.22 85.223C214.443 91.029 221.765 93.1265 227.571 89.904C229.535 88.8077 231.156 87.1869 232.252 85.223L232.271 85.1848C233.463 83.0016 235.751 81.6478 238.239 81.6478H280.569C285.45 81.5906 289.464 85.4899 289.531 90.3712L289.502 329.106Z",
    fill: "#4A4A4A"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M243.12 280.189C243.32 291.725 234.129 301.078 222.594 301.078C211.058 301.078 201.533 291.725 201.333 280.189C201.133 268.653 210.324 259.301 221.86 259.301C233.395 259.301 242.92 268.653 243.12 280.189Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M215.377 295.786C213.432 295.071 211.659 293.974 210.143 292.563C208.617 291.095 207.435 289.312 206.682 287.329C205.824 285.108 205.404 282.753 205.433 280.37C205.414 278.339 205.776 276.327 206.491 274.421C207.14 272.676 208.102 271.074 209.342 269.682C211.792 266.994 214.957 265.068 218.466 264.124C220.191 263.666 221.965 263.428 223.747 263.428C225.225 263.419 226.703 263.6 228.133 263.952C229.525 264.296 230.85 264.849 232.07 265.583C233.281 266.307 234.368 267.232 235.283 268.309C236.246 269.463 236.971 270.788 237.438 272.218C237.972 273.839 238.239 275.546 238.22 277.262C238.201 280.551 237.018 283.735 234.892 286.242C233.968 287.291 232.871 288.187 231.651 288.864C230.602 289.474 229.41 289.808 228.2 289.827C227.37 289.837 226.55 289.579 225.883 289.083C225.197 288.578 224.787 287.777 224.787 286.929C223.366 288.931 221.44 289.932 219.019 289.932C217.045 289.932 215.463 289.255 214.28 287.911C213.098 286.557 212.507 284.898 212.517 282.925C212.526 281.428 212.784 279.941 213.289 278.52C213.785 277.09 214.49 275.746 215.396 274.535C216.292 273.334 217.427 272.342 218.733 271.627C220.039 270.893 221.516 270.502 223.013 270.502C224.052 270.493 225.082 270.741 226.007 271.236C226.903 271.713 227.628 272.457 228.085 273.362L228.276 272.733C228.591 271.799 229.592 271.303 230.526 271.608C230.698 271.665 230.869 271.751 231.012 271.865C231.308 272.104 231.47 272.466 231.441 272.847C231.441 273.029 231.413 273.2 231.355 273.372L228.266 283.649C227.914 284.822 227.742 285.632 227.742 286.071C227.742 286.814 228.123 287.177 228.877 287.177C229.859 287.177 230.831 286.719 231.784 285.813C232.814 284.793 233.605 283.554 234.101 282.2C234.692 280.713 234.997 279.13 234.997 277.529C235.016 276.118 234.807 274.716 234.387 273.372C234.044 272.209 233.481 271.122 232.747 270.159C232.051 269.282 231.203 268.529 230.259 267.938C229.306 267.337 228.276 266.889 227.189 266.612C226.074 266.326 224.93 266.174 223.776 266.174C222.317 266.174 220.859 266.384 219.457 266.784C218.018 267.194 216.635 267.814 215.377 268.624C214.099 269.425 212.946 270.416 211.945 271.541C210.915 272.733 210.105 274.096 209.571 275.584C208.97 277.195 208.674 278.901 208.684 280.627C208.655 282.667 209.018 284.688 209.771 286.586C210.41 288.225 211.43 289.703 212.745 290.876C214.013 291.982 215.472 292.83 217.055 293.393C218.723 293.984 220.477 294.279 222.251 294.26C224.138 294.26 226.026 293.974 227.828 293.412C228.009 293.355 228.2 293.316 228.39 293.326C228.762 293.307 229.115 293.459 229.372 293.726C229.611 293.974 229.744 294.308 229.744 294.651C229.792 295.223 229.41 295.748 228.848 295.872C226.598 296.558 224.253 296.92 221.898 296.939C219.686 296.949 217.465 296.558 215.377 295.786ZM223.252 285.899C224.195 285.222 224.891 284.259 225.244 283.163L227.237 276.156L227.103 275.87C226.979 275.641 226.827 275.422 226.646 275.231C226.407 274.954 226.15 274.707 225.873 274.468C225.521 274.182 225.111 273.963 224.682 273.82C223.557 273.419 222.317 273.467 221.221 273.944C220.62 274.201 220.077 274.554 219.6 275.002C219.104 275.469 218.656 275.984 218.285 276.547C217.894 277.128 217.56 277.757 217.283 278.406C217.017 279.054 216.807 279.731 216.664 280.417C216.521 281.075 216.445 281.742 216.445 282.41C216.445 282.839 216.464 283.268 216.521 283.697C216.568 284.078 216.654 284.45 216.769 284.812C216.874 285.136 217.026 285.451 217.217 285.737C217.388 286.004 217.617 286.233 217.865 286.424C218.142 286.624 218.447 286.767 218.771 286.862C219.152 286.967 219.553 287.024 219.943 287.015C221.135 287.005 222.298 286.614 223.252 285.899Z",
    fill: "#DFFF02",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M242.653 208.562C242.853 220.098 233.663 229.451 222.127 229.451C210.591 229.451 201.067 220.098 200.866 208.562C200.666 197.026 209.857 187.674 221.393 187.674C232.929 187.664 242.443 197.017 242.653 208.562Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M234.874 206.655C228.334 202.365 215.492 202.365 209.248 206.655C206.921 207.094 205.205 209.143 205.301 211.603C205.396 214.378 216.922 214.378 216.827 211.603C216.789 210.411 216.312 209.315 215.578 208.457C219.706 207.523 224.502 207.523 228.697 208.457C228.02 209.325 227.619 210.411 227.667 211.603C227.762 214.378 239.289 214.378 239.193 211.603C239.079 209.143 237.22 207.094 234.874 206.655Z",
    fill: "#DFFF02",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M242.653 138.985C242.767 144.124 239.965 148.719 235.465 151.779V164.259L226.512 155.307C225.101 155.555 223.633 155.679 222.127 155.679C210.591 155.679 201.067 148.214 200.866 138.985C200.666 129.766 209.847 122.301 221.393 122.301C232.929 122.301 242.453 129.766 242.653 138.985Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M212.861 138.985C212.861 140.482 211.65 141.693 210.153 141.693C208.656 141.693 207.445 140.482 207.445 138.985C207.445 137.488 208.656 136.277 210.153 136.277C211.65 136.287 212.861 137.498 212.861 138.985Z",
    fill: "#DFFF02",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M224.444 138.985C224.444 140.482 223.234 141.693 221.737 141.693C220.24 141.693 219.029 140.482 219.029 138.985C219.029 137.488 220.24 136.277 221.737 136.277C223.234 136.287 224.444 137.498 224.444 138.985Z",
    fill: "#DFFF02",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M236.027 138.985C236.027 140.482 234.816 141.693 233.319 141.693C231.822 141.693 230.611 140.482 230.611 138.985C230.611 137.488 231.822 136.277 233.319 136.277C234.816 136.287 236.027 137.498 236.027 138.985Z",
    fill: "#DFFF02",
    stroke: "#4A4A4A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.1019a1990d01a373e69c83080eb35e61.svg";
export { ForwardRef as ReactComponent };